export default "__VITE_ASSET__D5Lf6guL__"